// extracted by mini-css-extract-plugin
export default {"container":"CorseError_container__d4+cD","item":"CorseError_item__FkwVt"};